import { BuilderComponentGroup } from '../types'

export const HeroDesignBlocks: BuilderComponentGroup = {
  id: 'hero',
  title: 'Hero',
  components: [
    {
      compId: 'hero-1',
      title: 'Hero 1',
      icon: 'HeroSimple',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-2',
      title: 'Hero 2',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-3',
      title: 'Hero 3',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-4',
      title: 'Hero 4',
      icon: 'HeroVideo',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-5',
      title: 'Hero 5',
      icon: 'HeroCarousel',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-6',
      title: 'Hero 6',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-7',
      title: 'Hero 7',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-8',
      title: 'Hero 8',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-9',
      title: 'Hero 9',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-10',
      title: 'Hero 10',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-11',
      title: 'Hero 11',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-12',
      title: 'Hero 12',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'hero-13',
      title: 'Hero 13',
      icon: 'HeroSplit',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
  ],
}
